let hostOrigin: string = undefined;
export const getHostOrigin = () => {
  if (hostOrigin) return hostOrigin;

  hostOrigin = getUrlParameter("hostOrigin");
  return hostOrigin;
};

function getUrlParameter(name) {
  return new URLSearchParams(window.location.search).get(name);
}
